import { v4 as uuidv4 } from 'uuid';

export function generateRandomUUID(): string {
  return crypto.randomUUID ? crypto.randomUUID() : uuidv4();
}
